import {wrap} from '../../../shared/loading-overlay'
;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('CreateUpdatePositionModalController', [
      '$location',
      '$uibModal',
      'logger',
      'SharedApi',
      'PositionApi',
      'EmployersApi',
      '$uibModalInstance',
      'selectedPositionId',
      'adminId',
      'userService',
      '$rootScope',
      '$window',
      '$timeout',
      '$scope',
      function controller(
        $location,
        $uibModal,
        logger,
        SharedApi,
        PositionApi,
        EmployersApi,
        $uibModalInstance,
        selectedPositionId,
        adminId,
        userService,
        $rootScope,
        $window,
        $timeout,
        $scope
      ) {
        let vm = this

        vm.pqeValues = [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

        $rootScope.$on('position-deleted', (event, {positionDeleted}) => {
          if (
            vm.positionRecord.id === positionDeleted &&
            !$rootScope.isPositionDeleted
          ) {
            logger.notify('error', 'Position is Deleted by Other Admin')
            vm.closePositionModal()
          }
        })
        vm.showOnSuccess = false
        vm.showOnError = false
        vm.alertMsg = ''

        vm.pqeOptions = {
          round: 1,
          from: -2,
          to: 11,
          step: 1,
          dimension: '+ years',
          scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+'],
        }

        vm.initializePosition = () => {
          console.debug('initializePosition')
          vm.modalTitle = 'Add Position'
          vm.editPositionModal = false
          vm.position = {
            employer: {},
            locations: [],
            practiceAreas: [],
            minPqe: -2,
            maxPqe: 11,
            pqe: '-2;11',
            positionType: 1,
            visible: true,
            contractTypeId: 1,
            occupationId: 1,
            description: '',
          }
          vm.selectedMinPqe = -2
          vm.selectedMaxPqe = 11
          vm.selectedPracticesShow = false
          vm.showPracticeButton = true
          vm.selectedLocation = false
          vm.showLocationButton = true
        }

        vm.initializeEditPosition = existingPosition => {
          console.debug('initializeEditPosition')
          vm.modalTitle = 'Edit Position'
          vm.editPositionModal = true
          // TODO: TechPreference to be discussed
          if (
            existingPosition.professionId === 'tech' ||
            !existingPosition.lawPreferences
          ) {
            existingPosition.lawPreferences = {
              minPqe:
                existingPosition.techPreferences &&
                existingPosition.techPreferences.minExperience
                  ? existingPosition.techPreferences.minExperience
                  : -2,
              maxPqe: 11,
            }
          }

          vm.pqeOptions = {
            round: 1,
            from: -2,
            to: 11,
            step: 1,
            dimension: '+ years',
            scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+'],
          }

          console.debug('existingPosition', existingPosition)

          vm.position = {
            title: existingPosition.title,
            locations: existingPosition.locations,
            expiresAt: existingPosition.expiresAt,
            minPqe: existingPosition.lawPreferences.minPqe
              ? Number.parseFloat(existingPosition.lawPreferences.minPqe)
              : -2,
            maxPqe: existingPosition.lawPreferences.maxPqe
              ? Number.parseFloat(existingPosition.lawPreferences.maxPqe)
              : 11,
            pqe: `${existingPosition.lawPreferences.minPqe};${existingPosition.lawPreferences.maxPqe}`,
            visible: existingPosition.visible,
            contractTypeId: existingPosition.contractTypeId,
            occupationId: existingPosition.occupationId,
            description: existingPosition.description,
            externalUrl: existingPosition.externalUrl,
          }
          if (existingPosition.type === 'Regular') vm.position.positionType = 1
          if (existingPosition.type === 'Custom') vm.position.positionType = 2
          if (existingPosition.type === 'Connect') vm.position.positionType = 3
          if (existingPosition.type === 'Speculative')
            vm.position.positionType = 4
          if (existingPosition.type === 'External') vm.position.positionType = 5
          if (existingPosition.specialties.length > 0)
            vm.position.practiceAreas = existingPosition.specialties.map(
              practiceArea => {
                practiceArea.isSelected = true
                return practiceArea
              }
            )

          vm.selectedPracticesShow = existingPosition.specialties.length > 0
          vm.showPracticeButton = existingPosition.specialties.length === 0

          if (existingPosition.locations.length > 0)
            vm.position.locations = existingPosition.locations.map(location => {
              location.isSelected = true
              return location
            })
          vm.selectedLocation = existingPosition.locations.length > 0
          vm.showLocationButton = existingPosition.locations.length === 0
          console.log('CreateUpdatePositionModalCtrl', vm)
          $scope.$applyAsync()
        }

        vm.positionDetailEditorOptions = {
          extraPlugins: 'colorbutton',
        }

        vm.notify = (type, message) => {
          switch (type) {
            case 'info':
              logger.log(message)
              break
            case 'success':
              logger.logSuccess(message)
              break
            case 'warning':
              logger.logWarning(message)
              break
            case 'error':
              logger.logError(message)
              break
            default:
              break
          }
        }

        vm.pqeChange = () => {
          var separator
          separator = vm.position.pqe.search(';')
          if (separator === 1) {
            vm.position.minPqe = Number(vm.position.pqe.slice(0, 1))
            vm.position.maxPqe = Number(vm.position.pqe.slice(2, 5))
          } else if (separator === 2) {
            vm.position.minPqe = Number(vm.position.pqe.slice(0, 2))
            vm.position.maxPqe = Number(vm.position.pqe.slice(3, 5))
          }
        }

        vm.changeEmployer = employer => {
          vm.position.employer = employer
          vm.position.employerId = employer.id
          vm.position.employer.address = employer.address
          vm.position.employer.isInHouse = false
          const employerType = employer.specialties
            .filter(({categoryId}) => categoryId === 2)
            .map(employerType => employerType.name)
            .join()
          if (employerType === 'In-House') vm.position.employer.isInHouse = true
        }

        vm.setPositionType = positionType => {
          if (positionType === 1) vm.position.type = 'Regular'
          if (positionType === 2) vm.position.type = 'Custom'
          if (positionType === 3) vm.position.type = 'Connect'
          if (positionType === 4) vm.position.type = 'Speculative'
          if (positionType === 5) vm.position.type = 'External'
          if (positionType !== 1 && positionType !== 5)
            vm.position.externalUrl = undefined
        }

        const createPosition = async () => {
          vm.setPositionType(vm.position.positionType)
          vm.position.description = vm.position.description
            ? vm.position.description
            : ''
          if (
            vm.position.practiceAreas.length > 0 &&
            vm.position.locations.length > 0
          ) {
            const payload = angular.copy(vm.position)
            // TODO: To be discussed professionId
            payload.professionId = 'law'
            payload.lawPreferences = {
              minPqe: payload.minPqe,
              maxPqe: payload.maxPqe,
            }
            payload.specialties = payload.practiceAreas

            delete payload.employer
            delete payload.positionType
            delete payload.pqe
            delete payload.practiceAreas
            delete payload.minPqe
            delete payload.maxPqe

            const {data, status} = await PositionApi.createPosition(payload)
            if (status === 201) {
              vm.initializePosition()
              vm.notify('success', 'Position has been added successfully.')
              $uibModalInstance.close({
                method: 'created',
                id: data.id,
                data: data,
              })
              $timeout(() => {
                $window.location.reload()
              }, 500)
            } else
              vm.notify('error', 'An error has occurred. Please try again.')
          } else {
            if (vm.position.locations.length === 0) {
              let message = 'Please select at least one Location.'
              vm.notify('error', message)
            }

            if (vm.position.practiceAreas.length === 0) {
              let message = 'Please select at least one practice area.'
              vm.notify('error', message)
            }
          }
        }

        vm.createPosition = async () => wrap(createPosition)

        const updatePosition = async () => {
          vm.setPositionType(vm.position.positionType)
          vm.position.description = vm.position.description
            ? vm.position.description
            : ''
          if (
            vm.position.practiceAreas.length > 0 &&
            vm.position.locations.length > 0
          ) {
            const payload = angular.copy(vm.position)

            // To be discussed professionId
            // payload.professionId = 'law'
            payload.lawPreferences = {
              minPqe: payload.minPqe,
              maxPqe: payload.maxPqe,
            }
            payload.specialties = payload.practiceAreas

            delete payload.employer
            delete payload.positionType
            delete payload.pqe
            delete payload.practiceAreas
            delete payload.minPqe
            delete payload.maxPqe

            // TODO: only update that field which are new in editable field in V1
            // let updateDto = {}
            // Object.keys(payload).forEach(data => {
            //   if (payload[data] !== vm.positionRecord[data])
            //     updateDto[data] = payload[data]
            //   if (data === 'specialties' || data === 'locations') {
            //     if (payload[data].length !== vm.positionRecord[data].length)
            //       updateDto[data] = payload[data]
            //   }
            // })
            // Object.keys(updateDto).forEach(
            //   key => updateDto[key] === undefined && delete updateDto[key]
            // )
            //
            const {data, status} = await PositionApi.updatePositionById(
              vm.positionRecord.id,
              payload
            )
            if (status === 200) {
              vm.notify('success', 'Position updated successfully.')
              $uibModalInstance.close({
                method: 'updated',
                id: vm.positionRecord.id,
                data: data,
              })
            } else
              vm.notify('error', 'An error has occurred. Please try again.')
          } else {
            if (vm.position.locations.length === 0) {
              let message = 'Please select at least one Location.'
              vm.notify('error', message)
            }

            if (vm.position.practiceAreas.length === 0) {
              let message = 'Please select at least one practice area.'
              vm.notify('error', message)
            }
          }
        }

        vm.updatePosition = async () => wrap(updatePosition)

        vm.openDeletePositionModal = async () => {
          const modalInstance = $uibModal.open({
            templateUrl: 'delete-position-modal.html',
            controller: 'DeletePositionController',
            controllerAs: 'ctrl',
            resolve: {
              positionId: function() {
                return vm.positionRecord.id
              },
            },
          })
          modalInstance.result.then(
            deletedPosition => {
              if (deletedPosition) {
                vm.alertMsg = 'Position deleted successfully.'
                vm.showOnSuccess = true
                vm.notify('success', 'Position deleted successfully.')
                $uibModalInstance.close({
                  method: 'deleted',
                  id: vm.positionRecord.id,
                })
              } else {
                vm.alertMsg = 'An error has occurred. Please try again.'
                vm.showOnError = true
              }
            },
            () => {}
          )
        }

        vm.openPracticeModal = (selectedPractice, event) => {
          event.preventDefault()
          event.stopPropagation()
          const onlyParentPracticeArea = vm.legalPracticeAreaList.filter(
            ({parentId}) => parentId === null
          )
          const modalInstance = $uibModal.open({
            templateUrl: 'practice-area-modal.html',
            controller: 'PracticeAreaController',
            controllerAs: 'ctrl',
            resolve: {
              practiceAreaList: function() {
                return onlyParentPracticeArea
              },
              selectedPractice: function() {
                return selectedPractice
              },
              limit: function() {
                return 0
              },
              isAdminProfile: function() {
                return false
              },
              displayNextButton: function() {
                return false
              },
            },
          })
          modalInstance.result.then(
            selectPractices => {
              vm.selectedPracticesShow = selectPractices.length > 0
              vm.position.practiceAreas = angular.copy(selectPractices)
            },
            () => {}
          )
        }

        vm.openLocationModal = (selectedLocations, event) => {
          event.preventDefault()
          event.stopPropagation()
          const modalInstance = $uibModal.open({
            templateUrl: 'locations-modal.html',
            controller: 'LocationsModalController',
            controllerAs: 'ctrl',
            resolve: {
              locationList: function() {
                return vm.locationsList
              },
              selectedLocations: function() {
                return selectedLocations
              },
              limit: function() {
                return 0
              },
              locationModalHeading: function() {
                return false
              },
              displayNextButton: function() {
                return false
              },
            },
          })
          modalInstance.result.then(
            selectedLocations => {
              vm.selectedLocation = selectedLocations.length > 0
              vm.position.locations = angular.copy(selectedLocations)
            },
            () => {}
          )
        }

        vm.changeStatus = status => {
          if (status === 200) {
            vm.alertMsg =
              'Congratulations! Position has been Successfully created.'
            vm.showOnSuccess = true
          } else if (status === 440) {
            $location.url('/signin')
          } else {
            vm.alertMsg = 'An error has occurred. Please try again.'
            vm.showOnError = true
          }
        }

        vm.showClass = ''
        vm.hideDropDown = () => {
          vm.showClass = ''
        }

        vm.closePositionModal = () => {
          $uibModalInstance.dismiss('cancel')
        }

        vm.startPosition = async () => {
          console.debug('startPosition')
          vm.user = await userService.getUser()
          vm.initializePosition()
          if (selectedPositionId) {
            const {
              data: positionRecord,
              status: positionStatus,
            } = await PositionApi.getPositionById(selectedPositionId)
            if (positionStatus === 200) {
              vm.positionRecord = positionRecord
              vm.initializeEditPosition(vm.positionRecord)
            }
          }

          const {
            data: employersList,
            status: employersStatus,
          } = await EmployersApi.getAllEmployers({
            isDeleted: false,
            include: ['id', 'name', 'address', 'specialties'],
          })
          if (employersStatus === 200) {
            vm.employersList = employersList.sort((a, b) =>
              a.name > b.name ? 1 : -1
            )
            if (selectedPositionId) {
              const employer = vm.employersList.find(
                ({id}) => vm.positionRecord.employerId === id
              )
              vm.changeEmployer(employer)
            }
          } else vm.changeStatus(employersStatus)
          const {
            data: legalPracticeAreaList,
            status: legalPracticeAreaStatus,
          } = await SharedApi.getCategoryById(1)
          if (legalPracticeAreaStatus === 200) {
            vm.legalPracticeAreaList = legalPracticeAreaList.specialties
          } else vm.changeStatus(legalPracticeAreaStatus)
          const {data: contractTypeList} = await SharedApi.getAllContractTypes()
          const {data: occupationList} = await SharedApi.getAllOccupations()
          vm.contractType = contractTypeList
          vm.occupations = occupationList
          const locationDto = {
            supported: true,
            regions: true,
          }
          const {
            data: locationsList,
            status: locationsStatus,
          } = await SharedApi.getAllLocations(locationDto)
          if (locationsStatus === 200) {
            vm.locationsList = locationsList
          } else vm.changeStatus(locationsStatus)
        }

        vm.startPosition()
      },
    ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/create-update-position/create-update-position-modal.ctrl.js